<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

@if (properties.length > 0) {
  <p-table #pt [value]="compositeListings" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="compositeListingId" selectionMode="single"
    [(selection)]="compositeListing" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
    [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
    currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
    sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
    [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
    <ng-template pTemplate="caption">
      <div class="d-block text-end justify-content-between align-items-center">
        <h1 style="float: left;margin: 6px;">CompositeListings</h1>
        <span>
          <!--clear filters-->
          @if (showFilter) {
            <button pButton pRipple class="p-button-text"
              style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
            (click)="reloadPage()">Clear Filters</button>
          }
          <!--add new-->
          @if (!outlineNewButton && shortTermRentalId) {
            <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
            (click)="onOpenFormAdd()">New CompositeListing +</button>
          }
          @if (outlineNewButton && shortTermRentalId) {
            <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
            (click)="onOpenFormAdd()">New CompositeListing +</button>
          }
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
      @if (showFilter) {
        <tr>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'compositeListingId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'compositeShortTermRentalId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalId', 'in')"></th>
          <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listingPriority', 'in')"></th> -->
          <th>
            <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="sitePriorities" appendTo="body"
              (onChange)="pt.filter($event.value, 'listingPriority', 'in')" styleClass="p-column-filter" placeholder="Filter"
              [showClear]="true" optionLabel="name" optionValue="value">
              <ng-template let-option pTemplate="item">
                <span>{{option.name}}</span>
              </ng-template>
            </p-dropdown>
          </th>
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
      }
    </ng-template>
    <ng-template pTemplate="body" let-compositeListing>
      <tr [pSelectableRow]="compositeListing">
        <td>{{compositeListing.compositeListingId}} </td>
        <td>{{getPropertyCode(compositeListing.compositeShortTermRentalId)}}</td>
        <td><a href="/property-edit/{{compositeListing.shortTermRentalId}}" target="_blank">{{getPropertyCode(compositeListing.shortTermRentalId)}}</a></td>
        <td>{{compositeListing.listingPriority}} </td>
        <td><span style="float:none">
          <a>
            <i class="pi pi-pencil" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(compositeListing)"></i>
          </a>
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>
}